export enum CommentOrigin {
  POST_PAGE = 'POST_PAGE',
  LESSON_PAGE = 'LESSON_PAGE',
  COMMUNITY_FEED = 'COMMUNITY_FEED'
}
